export enum CountdownTypesEnum {
  fixed = 'fixed',
  delay = 'delay',
  daily = 'daily',
  deadline = 'deadline',
}
